<template>
  <div class="home">
    <h1>Verifica Garanzia</h1>
    <hr>

    <ul class="nav nav-pills mb-4">
      <li class="nav-item">
        <span :class="'nav-link ' + ( current_state == 'start' ? 'active' : '')" aria-current="page" href="#">Inserimento dati</span>
      </li>
      
      <li class="nav-item">
        <span :class="'nav-link ' + ( current_state == 'result' ? 'active' : '')" href="#">Esito</span>
      </li>
    </ul>


    <div class="card" v-if="current_state == 'start'">
      <div class="card-body">
        <h4 class="mb-3">Inserimento dati</h4>

          <div class="row">
            <div class="col">
              <label>Codice della garanzia</label>
            </div>

            <div class="col">
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.code ? 'is-invalid' : '')" v-model="code">
            </div>

          </div>

          <div class="row">
            <div class="col">
              <label>Partita IVA registrante</label>
            </div>

            <div class="col">
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.vat_code ? 'is-invalid' : '')" v-model="vat_code">
            </div>

          </div>

          <div class="row">
            <div class="col">
              <button class="btn btn-primary w-100" @click.prevent="checkWarranty" :disabled="!code || !vat_code">Verifica</button>
            </div>

            

          </div>
          

      </div>
    </div>



    <div class="card" v-if="current_state == 'result'">
      <div class="card-body">
        <h4 class="mb-3">Esito verifica</h4>

        <div :class="'alert mb-5 ' + (check_result.success ? 'alert-success' : 'alert-danger')" v-html="check_result.message"></div>

        <div v-if="check_result.success">

          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <tbody>
                <tr>
                  <td>Codice garanzia</td>
                  <td><strong class="h3">{{ check_result.data.code }}</strong></td>
                </tr>
                <tr>
                  <td>Partita IVA registrante</td>
                  <td><strong class="h3">{{ check_result.data.vat_code }}</strong></td>
                </tr>
                <tr>
                  <td>Data decesso</td>
                  <td><strong class="h3">{{ formatDate(check_result.data.activated_at) }}</strong></td>
                </tr>
                <tr>
                  <td>Data registrazione</td>
                  <td><strong class="h3">{{ formatDate(check_result.data.registered_at) }}</strong></td>
                </tr>
                <tr>
                  <td>Nome salma</td>
                  <td><strong class="h3">{{ check_result.data.corpse_last_name }} {{ check_result.data.corpse_first_name }}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>


          
        </div>

        
        
        
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-6 text-center text-sm-start pb-3">
            <button class="btn btn-secondary" @click.prevent="current_state = 'start'">Torna indietro</button>
          </div>
          <div class="col-sm-6 text-center text-sm-end pb-3" v-show="check_result.success && check_result.data && check_result.data.id">
            Hai riscontrato un problema con il prodotto? <button class="btn btn-primary ml-2"  data-bs-toggle="modal" @click="report_result = {}" data-bs-target="#reportModal">Richiedi non conformità</button>
          </div>
        </div>
      </div>

    </div>




    <!-- CART ITEM NOTES MODAL | START -->
    <div class="modal fade" tabindex="-1" id="reportModal">
        <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">Segnala non conformità</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div v-if="check_result.data && check_result.data.code">

                  <div :class="'alert  mb-5 ' + ( report_result.success ? 'alert-success' : 'alert-warning' )" v-if="report_result.message">{{ report_result.message }}</div>

                  <p>Procedere con la segnalazione di non conformità per la garanzia con codice <strong>{{ check_result.data.code }}</strong>?<br>
                  I nostri incaricati vi ricontatteranno entro 24 ore.</p>
                </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-primary" @click.prevent="reportWarranty()" :disabled="report_result.success">Invia segnalazione</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
              </div>
            </div>
        </div>
    </div>
    <!-- CART ITEM NOTES MODAL | END -->

  </div>
</template>

<script>
// @ is an alias to /src

import CmMixin from '../../../webapp/src/mixins/CmMixin'
// import CmMixin from '../mixins/CmMixin'

export default {
  mixins: [ CmMixin ],
  name: 'Check',
  data: () => {
		return {
      districts: null,
      // current_state: 'registration',
      current_state: 'start',

      validation_errors : {

      },

      code: '',
      vat_code: '',

      check_result: {},

      report_result: {},
			
		}
	},
  mounted: function(){





    
  },
  methods:{



    checkWarranty: function( callback ){
       
      var self = this;

      var post_data = {
        code: this.code,
        vat_code: this.vat_code,
      };
    
      this.api.post( 'warranty/checkWarranty', post_data )
      .then(function (response) {

          self.check_result = response.data;
          self.current_state = 'result';
         
          
          if( typeof callback === 'function')
            callback();
      })
      .catch(function (error) {
          self.notification.error('Errore nella verifica del codice');
      });
    
    },

    reportWarranty: function( callback ){
      var self = this;

      var post_data = {
        code: this.code,
        vat_code: this.vat_code,
        id: this.check_result.data.id,
      };
    
      this.api.post( 'warranty/reportWarranty', post_data )
      .then(function (response) {

          self.report_result = response.data;
          
          if( typeof callback === 'function')
            callback();
      })
      .catch(function (error) {
          self.notification.error('Errore nella segnalazione');
      });
    },
  

  },
  computed:{
    
  }
  
}
</script>
